import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import TelegramIcon from '@mui/icons-material/Telegram';
import PublicIcon from '@mui/icons-material/Public';
import GitHub from '@mui/icons-material/GitHub';

import Awede1 from '../assets/images/Awede1.jpg';
import Awede2 from '../assets/images/Awede2.jpg';
import Awede3 from '../assets/images/Awede3.jpg';
import Awede4 from '../assets/images/Awede4.jpg';
import Awede5 from '../assets/images/Awede5.jpg';
import Chatgpt from '../assets/images/Chatgpt.jpg';
import Chatgpt1 from '../assets/images/Chatgpt1.jpg';
import Chatgpt3 from '../assets/images/Chatgpt3.jpg';
import Chatgpt4 from '../assets/images/Chatgpt4.jpg';
import ReactT from '../assets/images/React.jpg';
import React1 from '../assets/images/React1.jpg';
import React2 from '../assets/images/React2.jpg';
import React3 from '../assets/images/React3.jpg';
import React5 from '../assets/images/React5.png';
import React6 from '../assets/images/React6.png';
import React7 from '../assets/images/React7.png';
import Aikitchenapp from '../assets/images/aikitchenapp.png';
import Aikitchenapp1 from '../assets/images/aikitchenapp1.png';
import Aikitchenapp2 from '../assets/images/aikitchenapp2.png';
import Aikitchenapp3 from '../assets/images/aikitchenapp3.jpg';
import Shelf from '../assets/images/Shelf.jpg';
import Shelf1 from '../assets/images/Shelf1.jpg';
import Shelf2 from '../assets/images/Shelf3.jpg';
import Shelf3 from '../assets/images/Shelf4.jpg';
import Shelf4 from '../assets/images/Shelf5.jpg';
import Shelf5 from '../assets/images/Shelf6.jpg';
import Velro from '../assets/images/Velro.png';
import Velro1 from '../assets/images/Velro1.png';
import Velro2 from '../assets/images/Velro2.png';
import AbetElectronics from '../assets/images/AbetElectronics.jpg';
import AbetElectronics1 from '../assets/images/AbetElectronics1.jpg';
import AbetElectronics2 from '../assets/images/AbetElectronics2.jpg';
import AbetElectronics3 from '../assets/images/AbetElectronics3.jpg';
import Salesapp from '../assets/images/Salesapp1.jpg';
import Salesapp1 from '../assets/images/Salesapp.jpg';
import Salesapp2 from '../assets/images/Salesapp2.jpg';
import Salesapp3 from '../assets/images/Salesapp3.jpg';
import Salesapp4 from '../assets/images/Salesapp4.jpg';
import Salesapp5 from '../assets/images/Salesapp5.jpg';
import Salesapp6 from '../assets/images/Salesapp6.jpg';
import Salesapp7 from '../assets/images/Salesapp7.jpg';
import Telegram1 from '../assets/images/Telegram1.jpg';
import Telegrambot from '../assets/images/Telegrambot.jpg';
import Telegrambot2 from '../assets/images/Telegrambot2.jpg';
import Telegrambot3 from '../assets/images/Telegrambot3.jpg';
import Telegrambot4 from '../assets/images/Telegrambot4.jpg';
import Todo from '../assets/images/Todo.jpg';
import Todo1 from '../assets/images/Todo1.jpg';
import Todo2 from '../assets/images/Todo2.jpg';
import Todo3 from '../assets/images/Todo3.jpg';
import Todo4 from '../assets/images/Todo4.jpg';
import Todo5 from '../assets/images/Todo5.jpg';

const portfolioData = {
  name: 'Abrham Tesfaye',
  firstName: 'Abrham',
  lastName: 'Tesfaye',
  profession: 'Full-Stack Mobile & AI Engineer',
  tagline:
    'Building production mobile apps, scalable backends, and AI-powered systems — shipped to the App Store and Google Play.',
  about:
    'Full-Stack Mobile Engineer with 5+ years of experience building and deploying scalable mobile and web applications using React Native, Node.js, and modern JavaScript frameworks. Proven track record of delivering production-ready apps to the Google Play Store and Apple App Store, including real-time systems, payment integrations, and subscription-based platforms. Experienced in leading development teams and building end-to-end solutions from scratch — with growing specialization in AI-powered features, LLM integrations, and intelligent automation.',
  email: 'aberhamtesfaye@gmail.com',
  phone: '+251 922 346 685',
  phoneRaw: '+251922346685',
  location: 'Addis Ababa, Ethiopia',
  birthday: '28 August 1999',
  languages: ['English', 'Amharic'],
  cvPath: '/assets/documents/ab.pdf',
  socials: [
    {
      id: 'linkedin',
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/in/abrham-tesfaye-13541a19a',
      icon: LinkedInIcon,
    },
    {
      id: 'github',
      label: 'GitHub',
      href: 'https://github.com/ab2230',
      icon: GitHubIcon,
    },
    {
      id: 'telegram',
      label: 'Telegram',
      href: 'https://t.me/abthehuman',
      icon: TelegramIcon,
    },
  ],
  highlights: [
    { value: '5+', label: 'Years experience' },
    { value: '10+', label: 'Shipped products' },
    { value: '2', label: 'App stores' },
    { value: 'MSc', label: 'Software Engineering' },
  ],
  skills: [
    {
      title: 'Frontend & Mobile',
      items: ['React Native', 'React', 'Next.js', 'Expo', 'TypeScript', 'Redux'],
    },
    {
      title: 'Backend & Systems',
      items: [
        'Node.js',
        'Express',
        'Firebase / Cloud Functions',
        'REST APIs',
        'WebSockets',
        'Real-time systems',
      ],
    },
    {
      title: 'AI & Machine Learning',
      items: [
        'LLM integration',
        'RAG pipelines',
        'Prompt engineering',
        'Deep learning (ResNet, ArcFace)',
        'n8n automation',
        'OpenRouter / Gemini / OpenAI',
      ],
    },
    {
      title: 'Data & Tools',
      items: [
        'MongoDB',
        'MySQL',
        'Firestore',
        'VectorDB',
        'Git',
        'Play Console',
        'App Store Connect',
        'Agile / Scrum',
      ],
    },
  ],
  experiences: [
    {
      title: 'Lead Full-Stack Mobile Engineer',
      company: 'AddisSystems',
      date: 'Oct 2024 – Present',
      location: 'Addis Ababa',
      bullets: [
        'Led development of Shelf, a real-time inventory management mobile app (React Native + Node.js / Express).',
        'Rebuilt a legacy codebase into a scalable architecture and migrated reusable components.',
        'Implemented subscription tiers (free & premium), Addispay payments, and WebSocket-driven real-time updates.',
        'Owned Play Console listing, assets, deployment, and ongoing feature releases.',
      ],
      link: {
        label: 'View on Google Play',
        href: 'https://play.google.com/store/apps/details?id=com.mposapp&hl=en',
      },
    },
    {
      title: 'Lead Full-Stack Mobile Engineer',
      company: 'Velro',
      date: 'Jun 2025 – Aug 2025',
      location: 'Remote · Part-time',
      bullets: [
        'Led React Native development for a cross-border delivery platform connecting travelers and senders.',
        'Built real-time messaging and notification systems for traveler–sender communication.',
        'Deployed the application to both the Apple App Store and Google Play Store within three months.',
      ],
      links: [
        {
          label: 'App Store',
          href: 'https://apps.apple.com/il/app/velro/id6753633447',
        },
        {
          label: 'Google Play',
          href: 'https://play.google.com/store/apps/details?id=velro.velro.com&pli=1',
        },
      ],
    },
    {
      title: 'Prompt Engineer',
      company: 'EaglePoint AI',
      date: 'Feb 2026',
      location: 'Remote',
      bullets: [
        'Designed and evaluated high-quality coding prompts to test LLM reasoning and code generation.',
        'Produced validated prompts that exposed model limitations to support debugging and training workflows.',
      ],
    },
    {
      title: 'IT Systems Professional',
      company: 'Commercial Bank of Ethiopia',
      date: 'Jan 2023 – Jan 2025',
      location: 'Head Office',
      bullets: [
        'Worked across mobile banking, ATM systems, and POS infrastructure.',
        'Monitored and reported ATM system performance and operations.',
        'Participated in deployment of the ITM (Interactive Teller Machine) system.',
      ],
    },
    {
      title: 'Mobile App Developer',
      company: 'July-23rd-Technologies',
      date: 'Feb 2023 – Feb 2024',
      location: 'Remote · Part-time',
      bullets: [
        'Developed a sales management application with Expo, React Native, and Firebase.',
        'Built analytics dashboards with graphical data visualization.',
        'Implemented authentication and state management with Redux.',
      ],
    },
    {
      title: 'ERP Deployment Engineer',
      company: 'Ken Techno',
      date: 'Mar 2022 – Jan 2023',
      location: 'Addis Ababa',
      bullets: [
        'Deployed and configured ERP systems on Linux servers.',
        'Set up remote access and networking configurations.',
        'Gathered client requirements and designed system workflows.',
      ],
    },
  ],
  projects: [
    {
      id: 'shelf',
      featured: true,
      tag: 'React Native',
      title: 'Shelf — Real-Time Inventory',
      caption: 'Production inventory & sales platform',
      description:
        'Lead full-stack development of a real-time inventory management mobile application. Rebuilt legacy code into a scalable React Native + Express architecture, implemented free/premium subscriptions, payment integration, and WebSocket updates. Live on Google Play.',
      tech: ['React Native', 'Node.js', 'Express', 'Redux', 'WebSockets', 'Addispay'],
      images: [Shelf, Shelf1, Shelf2, Shelf3, Shelf4, Shelf5],
      links: [
        {
          label: 'Google Play',
          href: 'https://play.google.com/store/apps/details?id=com.mposapp&hl=en',
          icon: PublicIcon,
        },
      ],
    },
    {
      id: 'velro',
      featured: true,
      tag: 'React Native',
      title: 'Velro — Cross-Border Delivery',
      caption: 'Travelers & senders, connected',
      description:
        'Cross-border delivery platform connecting travelers and senders for affordable, reliable delivery. Led mobile development from scratch with real-time messaging and notifications. Shipped to App Store and Google Play.',
      tech: ['React Native', 'Django', 'Messaging', 'Push Notifications'],
      images: [Velro, Velro1, Velro2],
      links: [
        {
          label: 'App Store',
          href: 'https://apps.apple.com/il/app/velro/id6753633447',
          icon: PublicIcon,
        },
        {
          label: 'Google Play',
          href: 'https://play.google.com/store/apps/details?id=velro.velro.com&pli=1',
          icon: PublicIcon,
        },
      ],
    },
    {
      id: 'ai-kitchen',
      featured: true,
      tag: 'AI',
      title: 'AI Kitchen Chef',
      caption: 'Recipes from ingredients & images',
      description:
        'AI-powered mobile app that generates recipes from text or image-captured ingredients. Integrates Google Image Recognition, Gemini for recipe generation, OpenAI for food imagery, Apple/Google Sign-In, and RevenueCat subscriptions on a Firebase backend.',
      tech: ['React Native', 'Firebase', 'Gemini', 'OpenAI', 'RevenueCat'],
      images: [Aikitchenapp1, Aikitchenapp, Aikitchenapp2, Aikitchenapp3],
      links: [
        {
          label: 'App Store',
          href: 'https://apps.apple.com/us/app/ai-kitchen-chef/id6740346503',
          icon: PublicIcon,
        },
      ],
    },
    {
      id: 'abet',
      featured: true,
      tag: 'Full-Stack',
      title: 'Abet Electronics',
      caption: 'E-commerce app & website',
      description:
        'Full e-commerce experience for Abet Electronics — React Native mobile app and React web frontend backed by Node.js + MySQL. Cart, orders, favorites, multilingual UI (Amharic/English), and dark/light themes with real-time cart updates.',
      tech: ['React Native', 'React', 'Node.js', 'MySQL', 'REST'],
      images: [AbetElectronics, AbetElectronics1, AbetElectronics2, AbetElectronics3],
      links: [
        {
          label: 'Website',
          href: 'https://abetelectronics.com/',
          icon: PublicIcon,
        },
        {
          label: 'Android APK',
          href: 'https://abetelectronics.com/android/abet%20electronics.apk',
          icon: PublicIcon,
        },
      ],
    },
    {
      id: 'sales',
      featured: false,
      tag: 'React Native',
      title: 'Sales Management System',
      caption: 'Firebase-powered sales analytics',
      description:
        'Sales management application with Expo and React Native, Firebase integration, Redux auth/state, and dashboards with graphical analytics.',
      tech: ['React Native', 'Expo', 'Firebase', 'Redux'],
      images: [
        Salesapp,
        Salesapp1,
        Salesapp2,
        Salesapp3,
        Salesapp4,
        Salesapp5,
        Salesapp6,
        Salesapp7,
      ],
      links: [
        {
          label: 'GitHub',
          href: 'https://github.com/July-23rd-Technologies/Megenagna.git',
          icon: GitHub,
        },
      ],
    },
    {
      id: 'face-recognition',
      featured: false,
      tag: 'AI',
      title: 'Face Recognition System',
      caption: "Master's thesis · deep learning",
      description:
        'Advanced face recognition system combining ResNet50 feature extraction with an ArcFace angular-margin layer to improve accuracy and reduce racial and gender bias.',
      tech: ['Python', 'ResNet50', 'ArcFace', 'Deep Learning'],
      images: [Todo, Todo1, Todo2],
      links: [
        {
          label: 'GitHub',
          href: 'https://github.com/ab2230',
          icon: GitHub,
        },
      ],
    },
    {
      id: 'rag-chatbot',
      featured: false,
      tag: 'AI',
      title: 'RAG Contextual Chatbot',
      caption: 'Topic-aware LLM conversations',
      description:
        'Retrieval-augmented chatbot for context-aware conversations. Integrated LLMs via OpenRouter with custom document retrieval pipelines, contextual memory, and structured prompting.',
      tech: ['RAG', 'OpenRouter', 'LLMs', 'Vector retrieval'],
      images: [Chatgpt, Chatgpt1, Chatgpt3],
      links: [],
    },
    {
      id: 'email-ai',
      featured: false,
      tag: 'AI',
      title: 'AI Email Reviewer & Auto-Responder',
      caption: 'n8n + LLM automation',
      description:
        'Automated workflow to analyze, classify, summarize, and respond to emails using LLMs — end-to-end communication automation with n8n.',
      tech: ['n8n', 'LLMs', 'Automation'],
      images: [Chatgpt4, Chatgpt],
      links: [],
    },
    {
      id: 'awede',
      featured: false,
      tag: 'React',
      title: 'Awede Admin Dashboard',
      caption: 'Music streaming content admin',
      description:
        'Admin dashboard for uploading audio files and lyrics for Awede — a music, podcast, and audiobook streaming platform.',
      tech: ['React'],
      images: [Awede1, Awede2, Awede3, Awede4, Awede5],
      links: [
        {
          label: 'GitHub',
          href: 'https://github.com/ab2230/Admin-DashBoard.git',
          icon: GitHub,
        },
      ],
    },
    {
      id: 'chatgpt-ui',
      featured: false,
      tag: 'React',
      title: 'ChatGPT Web Interface',
      caption: 'Multi-model AI chat client',
      description:
        'Web application to access ChatGPT with selection of different AI models. React frontend and Node.js backend.',
      tech: ['React', 'Node.js'],
      images: [Chatgpt, Chatgpt1, Chatgpt3, Chatgpt4],
      links: [
        {
          label: 'Live demo',
          href: 'https://ab-chatgpt-client.onrender.com/',
          icon: PublicIcon,
        },
        {
          label: 'Frontend',
          href: 'https://github.com/ab2230/abChatGPT-front-end.git',
          icon: GitHub,
        },
        {
          label: 'Backend',
          href: 'https://github.com/ab2230/chat-GPT-SERVER.git',
          icon: GitHub,
        },
      ],
    },
    {
      id: 'restaurant',
      featured: false,
      tag: 'React',
      title: 'Restaurant Management System',
      caption: 'Menus, ratings & reviews',
      description:
        'Restaurant management web application with food and drink services, rating system, and customer reviews.',
      tech: ['React'],
      images: [React7, React6, React5, ReactT, React1, React2, React3],
      links: [
        {
          label: 'Live demo',
          href: 'https://626595c0e6c8985e08edd7c3--tiny-pegasus-b8b509.netlify.app/home',
          icon: PublicIcon,
        },
        {
          label: 'GitHub',
          href: 'https://github.com/ab2230/React-confusion.git',
          icon: GitHub,
        },
      ],
    },
    {
      id: 'telegram-bot',
      featured: false,
      tag: 'Python',
      title: 'Telegram File Bot',
      caption: 'Automated file management',
      description:
        'Python Telegram bot for uploading and managing files in a database, with automated posting and retrieval.',
      tech: ['Python', 'Telegram Bot API'],
      images: [Telegram1, Telegrambot, Telegrambot2, Telegrambot3, Telegrambot4],
      links: [
        {
          label: 'GitHub',
          href: 'https://github.com/ken-techno1234/Telegram-bot.git',
          icon: GitHub,
        },
      ],
    },
    {
      id: 'todo',
      featured: false,
      tag: 'React Native',
      title: 'TODO App',
      caption: 'Task management with React Native',
      description:
        'Simple, user-friendly TODO app for creating and managing tasks, reminders, and priorities.',
      tech: ['React Native'],
      images: [Todo, Todo1, Todo2, Todo3, Todo4, Todo5],
      links: [
        {
          label: 'GitHub',
          href: 'https://github.com/KingAdonay/Todo.git',
          icon: GitHub,
        },
      ],
    },
  ],
  education: [
    {
      degree: "Master's Degree in Software Engineering",
      school: 'Addis Ababa Science and Technology University',
      date: '2022 – 2024',
      note: 'Scholarship program',
    },
    {
      degree: "Bachelor's Degree in Software Engineering",
      school: 'Addis Ababa Science and Technology University',
      date: '2018 – 2022',
      note: 'CGPA 3.75 · Very great distinction',
    },
  ],
  certifications: [
    {
      title: 'Front-End Web Development with React',
      issuer: 'Coursera · HKUST',
    },
    {
      title: 'Bootstrap UI Frameworks',
      issuer: 'Coursera',
    },
    {
      title: 'Machine Learning',
      issuer: 'Stanford University · Coursera',
    },
    {
      title: 'Advanced Learning Algorithms',
      issuer: 'Coursera',
    },
  ],
  services: [
    {
      title: 'Mobile App Development',
      description:
        'Production React Native & Expo apps with real-time features, payments, and App Store / Play Store deployment.',
    },
    {
      title: 'Full-Stack Engineering',
      description:
        'End-to-end web and API systems with React, Next.js, Node.js, and modern architecture patterns.',
    },
    {
      title: 'AI Product Features',
      description:
        'LLM integrations, RAG pipelines, prompt systems, and intelligent automation wired into real products.',
    },
  ],
};

export default portfolioData;
